export default "__VITE_ASSET__3a7e09cc__"